import { Select } from '@material-ui/core';

import { withStyles } from '@material-ui/core';

export const DefaultSelectField = withStyles({
  root: {
    marginTop: '15px',
    height: '25px',
    width: 'fit-content',
    minWidth: '50px',
    marginRight: '10px',
  }
})(Select);
